import { useState, forwardRef } from 'react';
import FocusLock from 'react-focus-lock';
import icons from 'node-emoji/lib/emoji.json';
import {
  StyledEmojiPickerIcon,
  StyledEmojiPickerGrid,
  StyledEmojiPickerList,
} from './styled';
import { ModalEditableName } from '../../Modal';
import { useEmojiPickerContext } from '../../../contexts/emoji-picker';

const EmojiPickerList = forwardRef((props, ref) => {
  const { isOpen, listProps, iconProps } = useEmojiPickerContext();

  const [filter, setFilter] = useState(null);

  if (isOpen) {
    return (
      <FocusLock autoFocus returnFocus>
        <StyledEmojiPickerList ref={ref} {...listProps(ref, props)}>
          <ModalEditableName
            onChange={(e) => {
              setFilter(e.target.value);
            }}
            placeholder="Search icons"
            defaultValue={filter}
          />
          <StyledEmojiPickerGrid>
            {Object.entries(icons)
              .filter(
                // prettier-ignore
                (icon) =>
                    filter !== null ?
                    (icon[0].replace(/_/g, ' ').includes(filter)) ||
                    (icon[1] === filter) :
                    icon
              )
              .map((icon) => (
                <StyledEmojiPickerIcon
                  key={icon[0]}
                  title={icon[0].replace(/_/g, ' ')}
                  {...iconProps(icon[0])}
                >
                  {icon[1]}
                </StyledEmojiPickerIcon>
              ))}
          </StyledEmojiPickerGrid>
        </StyledEmojiPickerList>
      </FocusLock>
    );
  }
});

export default EmojiPickerList;
